export	const APPS_HELP_DATA = [
    {
        id: "app_movil",
        textButton: {
            default: "Descarga la app  en tu celular",
            translationPath: "apps.app_movil.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/911358048?h=45d5d74c58&badge=0&autopause=0&player_id=0&app_id=58479",
            translationPath: "apps.app_movil.url",
        },
    },
    {
        id: "app_web",
        textButton: {
            default: "Descarga la app en tu computador ",
            translationPath: "apps.app_web.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/912983190?h=b447d7f328&badge=0&autopause=0&player_id=0&app_id=58479",
            translationPath: "apps.app_web.url",
        },
    }
]